"use client";

import { useGetSignedUrlQuery } from "../lib/api/apiSlice";

interface SignedUrlParams {
  v?: string; // A/B test variant
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

/**
 * Hook to fetch ElevenLabs signed URL using RTK Query
 * @param shouldFetch - Pass true to trigger the fetch
 * @param params - Query parameters to pass to the API (v and UTM parameters)
 */
export const useSignedUrl = (
  shouldFetch: boolean = false,
  params?: SignedUrlParams
) => {
  const { data, isLoading } = useGetSignedUrlQuery(
    { params: params || {} },
    { skip: !shouldFetch }
  );

  return {
    signedUrl: data?.data?.signed_url || "",
    loading: isLoading,
  };
};
